import invariant from 'invariant'
import { isFSA } from 'flux-standard-action'
import {
  LIBRARY_DISCOUNT_SET_OUTLETS,
  LIBRARY_DISCOUNT_SET_DISCOUNT_DETAIL,
  LIBRARY_DISCOUNT_SET_DISCOUNTS,
  LIBRARY_DISCOUNT_SET_CURRENT_PAGE,
  LIBRARY_DISCOUNT_SET_TOTAL_PAGE,
  LIBRARY_DISCOUNT_UNSET_DISCOUNT,
  LIBRARY_DISCOUNT_SET_CREATE_DISCOUNT,
  LIBRARY_DISCOUNT_SHOW_DELETE_DISCOUNT_MODAL,
  LIBRARY_DISCOUNT_HIDE_DELETE_DISCOUNT_MODAL,
  LIBRARY_DISCOUNT_SET_DELETED_DISCOUNT,
  LIBRARY_DISCOUNT_IS_SUBMITTING_FORM
} from 'actions/library/discount/constants'

let initialState = {
  outlets: [],
  discounts: [],
  discountDetail: null,
  currentPage: null,
  totalPage: null,
  showDetail: false,
  newDiscount: undefined,
  deletedDiscount: null,
  showDeleteDiscountModal: false,
  isSubmittingForm: false
}

function reducer (state = initialState, action) {
  invariant(
    isFSA(action),
    `Invalid FSA action. See https://github.com/acdlite/flux-standard-action for info. Object: ${JSON.stringify(action)}`
  )

  let {type, payload} = action

  switch (type) {
    case LIBRARY_DISCOUNT_SET_OUTLETS:
      return {...state, outlets: payload.outlets}
    case LIBRARY_DISCOUNT_SET_DISCOUNTS:
      return {...state, discounts: payload.discounts}
    case LIBRARY_DISCOUNT_SET_CREATE_DISCOUNT:
      return {...state, discountDetail: null, showDetail: true, newDiscount: true}
    case LIBRARY_DISCOUNT_SET_DISCOUNT_DETAIL:
      return {...state, discountDetail: payload.discount, showDetail: true, newDiscount: false}
    case LIBRARY_DISCOUNT_UNSET_DISCOUNT:
      return {...state, discountDetail: null, showDetail: false, newDiscount: undefined}
    case LIBRARY_DISCOUNT_SET_TOTAL_PAGE:
      return {...state, totalPage: payload.totalPage}
    case LIBRARY_DISCOUNT_SET_CURRENT_PAGE:
      return {...state, currentPage: payload.currentPage}
    case LIBRARY_DISCOUNT_SHOW_DELETE_DISCOUNT_MODAL:
      return {...state, showDeleteDiscountModal: true}
    case LIBRARY_DISCOUNT_HIDE_DELETE_DISCOUNT_MODAL:
      return {...state, showDeleteDiscountModal: false}
    case LIBRARY_DISCOUNT_SET_DELETED_DISCOUNT:
      return {...state, deletedDiscount: payload.deletedDiscount}
    case LIBRARY_DISCOUNT_IS_SUBMITTING_FORM:
      return {...state, isSubmittingForm: payload.isSubmittingForm}
    default:
      return {...state}
  }
}

export default reducer



// WEBPACK FOOTER //
// ./app/reducers/library/discount.js